<template>
  <div class="text-center">
    <initial-loading v-if="init"/>
    <div :class="{'full': fullscrean}" v-else>
      <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      <div class="small text-muted font-weight-bold mb-4" v-if="text">{{text}}</div>
    </div>
  </div>
</template>

<script>
    import InitialLoading from './InitialLoading';
    export default {
      name: "loading",
      components: { InitialLoading },
      props: ['fullscrean', 'text', 'init'],
    }
</script>

<style scoped>
  .full {
    margin-top: 15vh;
  }
  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 65px;
  }
  .lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: var(--lecard-primary);
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
</style>
